import React from 'react';

export const CATEGORY_LABELS = {
  creativity: 'Creativity', emotion: 'Emotion', transitions: 'Transitions', clarity: 'Clarity',
};

export const TEAM_COLORS = ['purple', 'blue', 'green', 'orange', 'pink', 'red', 'yellow', 'teal'];

// Team colors are stored as names; paint them with the skin's tokens, never raw CSS named colors.
export function teamColor(name) {
  return `var(--ba-team-${TEAM_COLORS.includes(name) ? name : 'purple'})`;
}

export function teamByKey(teams = [], key) {
  return teams.find((team) => team.key === key) || { key, name: key || 'Team', color: 'purple' };
}

export function entrySubtitle(entry) {
  return entry?.artist ? `${entry.title} by ${entry.artist}` : entry?.title || 'Untitled beat';
}

export function Winner({ results }) {
  const winner = results?.winner;
  if (!winner) return null;
  if (winner.message === 'Ended early: not all scores were in') return <p className="battle-result-callout">Ended early: not all scores were in</p>;
  if (!winner.winner) return winner.message ? <p className="battle-result-callout">{winner.message}</p> : null;
  const team = teamByKey(results.teams, winner.winner);
  return <p className="battle-result-callout">
    <strong>{team.name}</strong> {winner.method === 'sudden_death' ? 'won in sudden death' : 'wins'}
  </p>;
}

export function BattleResults({ results, compact = false, showComments = false }) {
  if (!results) return null;
  const topEntries = (results.entries || []).filter((entry) => entry.rank && entry.rank <= 3)
    .sort((a, b) => a.rank - b.rank || a.position - b.position);
  return <section className={`battle-results${compact ? ' compact' : ''}`} aria-label="Battle results">
    <h2>Final scoreboard</h2>
    <Winner results={results} />
    <div className="battle-scoreboard">
      {(results.teams || []).map((team) => <article key={team.key} style={{ '--team-color': teamColor(team.color) }}>
        <span>{team.label}</span><h3>{team.name}</h3>
        <strong>{team.score == null ? team.score_text || 'Not scored yet' : Number(team.score).toFixed(2)}</strong>
        {team.wildcard_count > 0 && <small>{team.wildcard_count} wild {team.wildcard_count === 1 ? 'card' : 'cards'}</small>}
      </article>)}
    </div>
    <div className="battle-result-columns">
      <section><h3>Category awards</h3>
        {(results.category_awards || []).map((award) => <div className="battle-award" key={award.key}>
          <strong>{award.name}</strong>
          <span>{award.entries?.length ? award.entries.map((entry) => `#${entry.position} ${entry.title}`).join(', ') : 'No award'}</span>
        </div>)}
      </section>
      <section><h3>Top entries</h3>
        {topEntries.length ? topEntries.map((entry) => <div className="battle-top-entry" key={entry.id}>
          <b>#{entry.rank}</b><span>{entrySubtitle(entry)}</span><strong>{Number(entry.score).toFixed(2)}</strong>
        </div>) : <p>No fully judged entries.</p>}
      </section>
    </div>
    {showComments && (results.entries || []).some((entry) => entry.comments?.length) && <section className="battle-comments"><h3>Judge comments</h3>
      {(results.entries || []).filter((entry) => entry.comments?.length).map((entry) => <article key={entry.id}><strong>#{entry.position} {entry.title}</strong>{entry.comments.map((comment) => <p key={`${comment.judge_id}:${comment.comment}`}><b>{comment.judge_name}</b> {comment.comment}</p>)}</article>)}
    </section>}
  </section>;
}
